import { useSecurityAuditSummary } from '../../hooks/useSecurityAuditSummary';
import { SecurityAuditWarningIcon } from '../SecurityAuditWarningIcon';

export const SecurityAuditIndicator = () => {
    const { hasIssues } = useSecurityAuditSummary();

    return hasIssues ? <SecurityAuditWarningIcon /> : null;
};
